<template>
  <div>
    <center><h6>Accounts</h6></center>
    <h5 class="info-text">Provide the bank accounts that you want to track</h5>
    <div class="row justify-content-center">
      <div class="row col-12 ustify-content-center"><ol v-html="addedAccounts"></ol></div>
      <p>&nbsp;</p>
      <p-button type="info" name="accounts"
        @click.prevent="callMonoConnect" 
        class="info" 
        v-validate="modelValidations.accounts"
         v-model="model.accounts"
        round >{{ LinKButtonText }}</p-button>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Wizard, WizardTab } from 'src/components/UIComponents'

  export default {
    data() {
      return {
        addedAccounts: '',
        LinKButtonText: 'Link Bank Account',
        model: {
          accounts: 0
        },
        modelValidations: {
          accounts: {
            required: true,
            min_value: 1
          }
        }
      }
    },
    methods: {
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model)
          return res
        })
      },
      callMonoConnect () {
           
        let globalThis = this

        var connect;
        var config = {
          key: process.env.VUE_APP_MONO_LIVE_PUBLIC_KEY,
          onSuccess: function (response) {
            console.log(JSON.stringify(response))
            console.log(JSON.stringify(response.code))
            
            Vue.prototype.$http.post('onboarding/wizard/add_account', {
              tempCode: response.code,

            })
            .then(response =>{

              console.log(JSON.stringify(response))
              console.log ('1st after ' + globalThis.model.accounts)
              globalThis.model.accounts++
              //globalThis.modelValidations.accounts
              //const isValidated = globalThis.validate()
              globalThis.validate()
              globalThis.LinKButtonText = 'Link Another Bank Account'
              globalThis.addedAccounts += "<li>Account " + response.data.account.accountNumber 
                + " of " + response.data.account.institution.name + " added successfully</li>"
            })
            //.catch(error => {console.error(error)})
            .catch()
          },
          onClose: function () {
            console.log('user closed the widget.')
          }
        };
        connect = new Connect(config);
        connect.setup()

        connect.open()
      },

      monoScript () {
        let monoScript = document.createElement('script')
        monoScript.setAttribute('src', 'https://connect.withmono.com/connect.js')
        document.head.appendChild(monoScript)
      }
    },

    mounted () {
      this.monoScript ()
    }
  }
</script>
<style lang="scss">
  h6 {display: block !important;}
</style>
